<template>
    <div class="fill-height of-y d-flex flex-column">

        <div class="px-12 d-flex justify-space-around flex-wrap pt-4">
            <app-landing-card-online-devices class="mb-8 mx-2"/>
            <app-landing-card-average-productivity class="mb-8 mx-2"/>
<!--            <app-landing-card-total-work-time class="mb-8 mx-2"/>-->
            <app-landing-card-total-active-time class="mb-8 mx-2"/>
            <app-landing-card-employee-turnout class="mb-8 mx-2"/>
            <app-landing-card-top-apps class="mb-8 mx-2"/>
            <app-landing-card-activity-distribution class="mb-8 mx-2"/>
            <app-landing-card-target-resolution class="mb-8 mx-2"/>
            <app-landing-card-total-unpoductive class="mb-8 mx-2"/>
        </div>

        <div>
            <app-landing-graph-time-activity-per-team class="mb-8 mx-12" />

            <div class="d-flex flex-wrap">
                <div class="flex-grow-1 flex-equal my-8 mx-12 d-flex justify-center">
                    <app-landing-graph-activity-distribution class="flex-grow-1"/>
                </div>
                <div class="flex-grow-1 flex-equal my-8 mx-12 d-flex justify-center">
                    <app-landing-graph-top-apps class="flex-grow-1"/>
                </div>
            </div>

<!--            <app-landing-graph-team-app-usage-last7-days class="mb-8 mx-12" />-->

        </div>
    </div>
</template>

<script>

import AppLandingCardOnlineDevices from "@/components/Dashboard/Landing/AppLandingCardOnlineDevices";
import AppLandingCardAverageProductivity from "@/components/Dashboard/Landing/AppLandingCardAverageProductivity";
import AppLandingCardTotalWorkTime from "@/components/Dashboard/Landing/AppLandingCardTotalWorkTime";
import AppLandingCardEmployeeTurnout from "@/components/Dashboard/Landing/AppLandingCardEmployeeTurnout";
import AppLandingCardTopApps from "@/components/Dashboard/Landing/AppLandingCardTopApps";
import AppLandingCardActivityDistribution from "@/components/Dashboard/Landing/AppLandingCardActivityDistribution";
import AppLandingCardTargetResolution from "@/components/Dashboard/Landing/AppLandingCardTargetResolution";
import AppLandingCardTotalUnpoductive from "@/components/Dashboard/Landing/AppLandingCardTotalUnpoductive";
import AppLandingGraphTimeActivityPerTeam from "@/components/Dashboard/Landing/AppLandingGraphTimeActivityPerTeam";
import AppLandingGraphActivityDistribution from "@/components/Dashboard/Landing/AppLandingGraphActivityDistribution";
import AppLandingGraphTopApps from "@/components/Dashboard/Landing/AppLandingGraphTopApps";
import AppLandingGraphTeamAppUsageLast7Days from "@/components/Dashboard/Landing/AppLandingGraphTeamAppUsageLast7Days";
import AppLandingCardTotalActiveTime from "@/components/Dashboard/Landing/AppLandingCardTotalActiveTime.vue";
export default {
    components: {
        AppLandingCardTotalActiveTime,
        AppLandingGraphTeamAppUsageLast7Days,
        AppLandingGraphTopApps,
        AppLandingGraphActivityDistribution,
        AppLandingGraphTimeActivityPerTeam,
        AppLandingCardTotalUnpoductive,
        AppLandingCardTargetResolution,
        AppLandingCardActivityDistribution,
        AppLandingCardTopApps,
        AppLandingCardEmployeeTurnout,
        AppLandingCardTotalWorkTime, AppLandingCardAverageProductivity, AppLandingCardOnlineDevices},
    props: {},
    data() {
        return {

        }
    },

}
</script>

<style scoped>

</style>